import React from "react";
import ManasaImage from "../assets/m.JPG";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-scroll";

const Home = () => {
  return (
    <div
      name="home"
      className="h-screen w-full bg-gradient-to-b from-black via-black to-gray-800"
    >
      <div className="max-w-screen-lg mx-auto flex flex-col items-center justify-center h-full px-3 md:flex-row">
        <div className="flex flex-col justify-center h-full md:p-8">
          <h2 className="text-4xl sm:text-5xl font-bold text-white">
            I'm a Software Engineer!
          </h2>
          <p className="text-gray-500 py-4 max-w-md">
            - A very passionate coder.
            <br />
            - Currently deeply in love with building systems!
            <br />
            - Let's build amazing things!
          </p>

          <div>
            <Link
              to="contact"
              smooth
              duration={500}
              className="group text-white w-fit px-6 py-3 my-2 flex items-center rounded-md bg-gradient-to-r from-cyan-500 to-blue-500 cursor-pointer"
            >
              Get in touch!
              <span className="group-hover:rotate-90 duration-300">
                <MdOutlineKeyboardArrowRight size={25} className="ml-1" />
              </span>
            </Link>
          </div>
        </div>

        <div>
          <img
            src={ManasaImage}
            alt="my profile"
            className=""
          />
        </div>
      </div>
    </div>
  );
};

export default Home;
